module.exports = __webpack_public_path__ + "static/media/th.9c1e01fc.svg";